import script from "./Iicc.vue?vue&type=script&setup=true&lang=js"
export * from "./Iicc.vue?vue&type=script&setup=true&lang=js"

import "./Iicc.vue?vue&type=style&index=0&id=98cf8532&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98cf8532"]])

export default __exports__